module.exports = __webpack_public_path__ + "img/ic_edit.ac64865a.svg";